import React, { useState, useEffect } from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'
import moment from 'moment'

import VfText from '../VfText'

import styles from './Countdown.Styles'

const DEFAULT_COUNTDOWN = {
  days: 0,
  time: '00:00:00'
}

const getTime = (to, format) => {
  if (!to || !format) {
    return DEFAULT_COUNTDOWN
  }
  const diff = moment.duration(moment(to, format).diff(moment()))

  if (diff.asSeconds() < 0) {
    return DEFAULT_COUNTDOWN
  }
  const days = Math.floor(diff.asDays()),
    minutes = (diff.minutes() + '').padStart(2, '0'),
    seconds = (diff.seconds() + '').padStart(2, '0')
  let hours = diff.hours()

  if (days === 1) {
    hours += 24
  }
  hours = (hours + '').padStart(2, '0')

  return {
    days,
    time: `${hours}:${minutes}:${seconds}`
  }
}

function Countdown({ to, format }) {

  const [count, setCount] = useState(() => getTime(to, format))

  useEffect(() => {
    const interval = setInterval(() => setCount(() => getTime(to, format)), 1000)
    return () => {
      clearInterval(interval)
    }
  }, [format, to])

  return (
    <View style={styles.container}>
      {(count.days >= 2) && <>
        <VfText
          i18nKey={count.days}
          size="h1"
          weight="bold"
          color={Colors.white}
        />
        <VfText
          i18nKey="migration_label_days"
          size="h4"
          color={Colors.white}
          style={styles.smallLabel}
        />
      </>}
      <VfText
        i18nKey={count.time}
        placeHolders={[ContentManager.translate('migration_label_days')]}
        size="h1"
        weight="bold"
        color={Colors.white}
      />
    </View>
  )
}

Countdown.defaultProps = {

}

Countdown.propTypes = {
  to: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired
}

export default Countdown
